import { useReducer } from 'react'

type StepAction = { type: 'SET_STEP'; payload: number } | { type: 'RESET' }

interface StepState {
  steps: number
  currentStep: number
}

const useStepReducer = () => {
  const [step, stepDispatch] = useReducer(stepReducer, initialStepState)

  return {
    step,
    stepDispatch
  }
}

const initialStepState: StepState = {
  steps: 3,
  currentStep: 1
}

const stepReducer = (state: StepState, action: StepAction): StepState => {
  switch (action.type) {
    case 'SET_STEP':
      return {
        ...state,
        currentStep: Math.min(Math.max(action.payload, 1), state.steps)
      }
    case 'RESET':
      return {
        ...state,
        currentStep: 1
      }
    default:
      return state
  }
}

export { useStepReducer }
export type { StepState, StepAction }
